import { ErrorsRoute } from 'admin/routes/errors'
import Impersonate from 'admin/routes/impersonate'
import StatusesRoute from 'admin/routes/statuses'
import UpgradePopup from 'components/UpgradePopup'
import { useDispatch } from 'react-redux'
import { Navigate, Route, Routes, useNavigate } from 'react-router'
import { StoreThunkDispatch } from '../../../store/state'
import { AdminHeader } from '../../components/AdminHeader'
import AppsRoute, { AppDetailsRoute } from '../../routes/apps'
import FeaturesManager from '../../routes/features'
import HomeConfig from '../../routes/home-config'
import InfoBoxes from '../../routes/info_boxes/InfoBoxesRoute'
import NetworkStatus from '../../routes/networks'
import PlansRoute from '../../routes/plans'
import QuotesRoute from '../../routes/quotes'
import QuoteKeywords from '../../routes/quotes/QuoteKeywords'
import QuoteTagsManager from '../../routes/quotes/QuoteTagsManager'
import CSKeywords from '../../routes/statuses/CSKeywords'
import CSTagsManager from '../../routes/statuses/CSTagsManager'
import StreamGroupsManager from '../../routes/stream_groups'
import TeamMembers from '../../routes/team'
import { VideoTrainingConfig } from '../../routes/training'
import { WriterConfig } from '../../routes/writer'
import { AdminNav } from './AdminNav'
import styles from './AdminRoot.pcss'

export const ADMIN_PATHNAME = '/admin'

export function AdminRoot() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const navigate = useNavigate()

  return (
    <div className={styles.layout}>
      <AdminHeader className={styles.header} />
      <div className={styles.sidenav}>
        <AdminNav />
      </div>
      <div className={styles.content} data-test="admin-content">
        <Routes>
          <Route path="support">
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users" element={<Impersonate />} />
            <Route path="apps" element={<AppsRoute />} />
            <Route path="apps/:id" element={<AppDetailsRoute />} />
            <Route path="team" element={<TeamMembers />} />
          </Route>
          <Route path="business">
            <Route index element={<Navigate to="plans" replace />} />
            <Route path="plans" element={<PlansRoute />} />
            <Route path="features" element={<FeaturesManager />} />
          </Route>
          <Route path="onboarding">
            <Route index element={<Navigate to="video-training" replace />} />
            <Route path="video-training/*" element={<VideoTrainingConfig />} />
            <Route path="info-boxes" element={<InfoBoxes />} />
          </Route>
          <Route path="product">
            <Route index element={<Navigate to="writer" replace />} />
            <Route path="writer/*" element={<WriterConfig />} />
            <Route path="home-config" element={<HomeConfig />} />
            <Route path="content-panels" element={<StreamGroupsManager />} />
            <Route path="quotes/tags" element={<QuoteTagsManager />} />
            <Route path="quotes/keywords" element={<QuoteKeywords />} />
            <Route path="quotes" element={<QuotesRoute />} />
            <Route path="conversation-starters/tags" element={<CSTagsManager />} />
            <Route path="conversation-starters/keywords" element={<CSKeywords />} />
            <Route path="conversation-starters" element={<StatusesRoute />} />
          </Route>
          {/* <Route path="checkout-ui" element={<CheckoutUI />} /> */}
          <Route path="live">
            <Route index element={<Navigate to="networks-status" replace />} />
            <Route path="networks-status" element={<NetworkStatus />} />
            <Route path="errors" element={<ErrorsRoute />} />
          </Route>
          <Route path="/" element={<Navigate to="support/users" replace />} />
        </Routes>
      </div>
      <UpgradePopup />
    </div>
  )
}

export default AdminRoot
